import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Truck, Award } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative mt-32 border-t border-white/5 bg-[#050507] overflow-hidden">
      {/* Feature strip */}
      <div className="border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { Icon: Truck, t: "Fast Shipping", s: "Tracked & insured worldwide" },
            { Icon: ShieldCheck, t: "Authenticated", s: "Every sealed product verified" },
            { Icon: Award, t: "Collector Grade", s: "Curated for serious buyers" },
            { Icon: Sparkles, t: "Kavo Points", s: "Earn rewards on every order" },
          ].map(({ Icon, t, s }, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-md border border-[#B026FF]/30 bg-[#B026FF]/5 flex items-center justify-center text-[#B026FF]">
                <Icon size={18} />
              </div>
              <div>
                <div className="font-medium text-white">{t}</div>
                <div className="text-sm text-white/50">{s}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 py-20 grid grid-cols-2 md:grid-cols-4 gap-12">
        <div>
          <div className="font-display font-extrabold text-2xl text-white">KAVO<span className="text-[#B026FF]">.</span>CARDS</div>
          <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
            A premium destination for Pokémon TCG collectors. Booster boxes, singles, plushies, and the gear to protect them.
          </p>
        </div>
        <FooterCol title="Shop" links={[
          { to: "/shop/booster-boxes", label: "Booster Boxes" },
          { to: "/shop/elite-trainer-boxes", label: "Elite Trainer Boxes" },
          { to: "/shop/single-cards", label: "Single Cards" },
          { to: "/shop/plushies", label: "Plushies" },
        ]} />
        <FooterCol title="Essentials" links={[
          { to: "/shop/sleeves", label: "Sleeves" },
          { to: "/shop/toploaders", label: "Toploaders" },
          { to: "/shop/deck-boxes", label: "Deck Boxes" },
          { to: "/shop/binders", label: "Binders" },
        ]} />
        <FooterCol title="Account" links={[
          { to: "/account", label: "My Account" },
          { to: "/account?tab=orders", label: "Orders" },
          { to: "/account?tab=loyalty", label: "Kavo Points" },
        ]} />
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/40 tracking-wider uppercase font-mono">© {new Date().getFullYear()} Kavo Cards — All rights reserved</div>
          <div className="text-xs text-white/40 tracking-wider uppercase font-mono">Pokémon™ is a trademark of its respective owners. Kavo Cards is an independent retailer.</div>
        </div>
      </div>

      {/* Massive watermark */}
      <div aria-hidden className="select-none pointer-events-none w-full overflow-hidden">
        <div className="text-center font-display font-black leading-[0.85] tracking-tighter text-transparent" style={{ fontSize: "min(22vw, 320px)", WebkitTextStroke: "1px rgba(255,255,255,0.06)" }}>
          KAVO CARDS
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-[11px] tracking-[0.25em] uppercase text-[#B026FF] font-bold">{title}</div>
      <ul className="mt-5 space-y-3">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="text-sm text-white/70 hover:text-white transition">{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
